import { observer } from 'mobx-react-lite';

import { Button } from '@/components/ui/Button';
import { XStack, YStack } from '@/components/ui/layout/layout';

import { MeetingDebugCard } from './components/meeting-debug-card';
import { MeetingDebugSessionCard } from './components/meeting-debug-session-card';
import { buildMeetingDebugCards } from './meeting-debug.cards';
import { useMeetingDebugLog } from './meeting-debug.hooks';
import { meetingDebugStore } from './meeting-debug.store';

export const MeetingDebug = observer(
  ({ meetingId }: { meetingId?: string }) => {
    useMeetingDebugLog(meetingId);

    const allCards = buildMeetingDebugCards(
      meetingDebugStore.eventsByMeetingId,
      meetingDebugStore.globalEvents
    );
    const cards = meetingId
      ? allCards.filter((card) => card.meetingId === meetingId.toLowerCase())
      : allCards;

    return (
      <YStack className="h-full overflow-y-auto px-4 py-4 sm:py-8 gap-4 max-w-screen-lg mx-auto w-full">
        <XStack className="items-center justify-between gap-4">
          <p className="text-foreground-muted text-sm">
            What meeting notes detected, and why a note started or stopped.
          </p>
          <Button
            variant="outline"
            size="sm"
            onClick={() => meetingDebugStore.load(meetingId)}
          >
            Refresh
          </Button>
        </XStack>
        <MeetingDebugSessionCard meetingId={meetingId} />
        {cards.length === 0 ? (
          <p className="text-sm text-foreground-muted">Nothing recorded yet.</p>
        ) : (
          <YStack className="gap-3">
            {cards.map((card) => (
              <MeetingDebugCard
                key={card.key}
                card={card}
                defaultOpen={meetingId !== undefined}
              />
            ))}
          </YStack>
        )}
      </YStack>
    );
  }
);
